<template lang="pug">
.print-section
    BaseHeader(
        :titulo='translate("view.title")',
        :voltarPara='{ route: "denuncias" }'
    )
    .visualizar-denuncia
        .visualizar-denuncia__bloco
            h3.visualizar-denuncia__titulo {{ translate('view.labels.dados_denuncia.title') }}
            .visualizar-denuncia__card
                .resume
                    .resume__item
                        .resume__label {{ translate('view.labels.dados_denuncia.codigoId') }}
                        .resume__value {{ row?.idDenuncia || '-' }}
                    .resume__item
                        .resume__label {{ translate('view.labels.dados_denuncia.dtConsulta') }}
                        .resume__value {{ row?.dataConsulta || '-' }}
                    .resume__item
                        .resume__label {{ translate('view.labels.dados_denuncia.user') }}
                        .resume__value {{ row?.usuario || '-' }}
        .visualizar-denuncia__bloco
            h3.visualizar-denuncia__titulo {{ translate('view.labels.dados_pesquisados.title') }}
            .visualizar-denuncia__dados-pesquisados
                .visualizar-denuncia__card.visualizar-denuncia__card--header
                    .card-header
                        h4.card-header__theader {{ translate('view.labels.dados_pesquisados.positivo') }}
                        h4.card-header__theader {{ translate('table.columns.actions') }}
                    .card-bd
                        .resume.resume--vertical
                            .resume__item.resume__item--normal(
                                v-for='car in listaCarPositivo',
                                :key='removerMascara(car)'
                            )
                                .resume__text
                                    .resume__label {{ translate('view.labels.dados_pesquisados.car') }}
                                    .resume__value {{ car || '-' }}
                                .resume__action
                                    el-checkbox#checkbox-car-positivo(
                                        size='large',
                                        :checked='checked(car)',
                                        @change='mudarCheckbox(car)'
                                    )
                            .resume__item.resume__item--normal(
                                v-for='cpf in listaCpfPositivo',
                                :key='removerMascara(cpf)'
                            )
                                .resume__text
                                    .resume__label {{ translate('view.labels.dados_pesquisados.cpf') }}
                                    .resume__value {{ cpf || '-' }}
                                .resume__action
                                    el-checkbox#checkbox-cpf-positivo(
                                        size='large',
                                        :checked='checked(cpf)',
                                        @change='mudarCheckbox(cpf)'
                                    )
                            .resume__item.resume__item--normal(
                                v-for='cnpj in listaCnpjPositivo',
                                :key='removerMascara(cnpj)'
                            )
                                .resume__text
                                    .resume__label {{ translate('view.labels.dados_pesquisados.cnpj') }}
                                    .resume__value {{ cnpj || '-' }}
                                .resume__action
                                    el-checkbox#checkbox-cnpj-positivo(
                                        size='large',
                                        :checked='checked(cnpj)',
                                        @change='mudarCheckbox(cnpj)'
                                    )
                .visualizar-denuncia__card.visualizar-denuncia__card--header
                    .card-header
                        h4.card-header__theader {{ translate('view.labels.dados_pesquisados.negativo') }}
                    .card-bd
                        .resume.resume--vertical
                            .resume__item(
                                v-for='car in listaCarNegativo',
                                :key='removerMascara(car)'
                            )
                                .resume__label {{ translate('view.labels.dados_pesquisados.car') }}
                                .resume__value {{ car || '-' }}
                            .resume__item(
                                v-for='cpf in listaCpfNegativo',
                                :key='removerMascara(cpf)'
                            )
                                .resume__label {{ translate('view.labels.dados_pesquisados.cpf') }}
                                .resume__value {{ cpf || '-' }}
                            .resume__item(
                                v-for='cnpj in listaCnpjNegativo',
                                :key='removerMascara(cnpj)'
                            )
                                .resume__label {{ translate('view.labels.dados_pesquisados.cnpj') }}
                                .resume__value {{ cnpj || '-' }}
        DenunciaResultado
        .visualizar-denuncia__footer(
            v-if='!!state.resultado',
            v-show='!state.exportando'
        )
            button.visualizar-denuncia__button.visualizar-denuncia__button--secondary(
                @click='irListaDenuncia'
            )
                span {{ i18n.t('denuncia.view.buttons.retornar') }}
            //- button.visualizar-denuncia__button(@click='exportElement')
            //-     span {{ i18n.t('denuncia.view.buttons.export') }}
</template>
<script>
import {
    defineComponent,
    getCurrentInstance,
    computed,
    onMounted,
    onUnmounted,
    reactive
} from 'vue';
import useShareReportInsert from '@/modules/denuncia/composition/useShareReport';
import i18n from '@/main';

export default defineComponent({
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        TabelaContratosRelacionadosDenuncia: () =>
            import(
                '@/modules/denuncia/views/components/TabelaContratosRelacionadosDenuncia'
            ),
        DenunciaResultado: () =>
            import('@/modules/denuncia/views/components/DenunciaResultado')
    },
    props: {
        row: {
            type: Object,
            required: true
        },
        id: {
            type: [String, Number],
            required: true
        }
    },
    mounted() {
        if (!this.row) {
            this.irListaDenuncia();
        }
    },
    setup({ row, id }) {
        const { state, clear, adicionarResultado, exportResults } =
            useShareReportInsert();
        const vm = getCurrentInstance().proxy;
        const translate = key => i18n.t(`denuncia.${key}`);
        const removerMascara = value => value?.replace(/[^a-zA-Z0-9]/g, '');

        const data = reactive({
            checkboxValues: {},
            resultados: []
        });
        const listaCpfPositivo = computed(() => {
            const lista = row?.listaCpfCnpj.split(',');
            const listaCpf = lista?.filter(
                cpf => removerMascara(cpf)?.length === 11
            );

            return (
                listaCpf?.filter(cpf =>
                    row?.dadosDenucias.find(dado => {
                        const dadosDenuciasListaCpfCnpj =
                            dado.cpfCnpj?.split(',');
                        return (
                            dadosDenuciasListaCpfCnpj?.includes(cpf) ||
                            dadosDenuciasListaCpfCnpj?.includes(
                                removerMascara(cpf)
                            )
                        );
                    })
                ) || []
            );
        });

        const listaCnpjPositivo = computed(() => {
            const lista = row?.listaCpfCnpj.split(',');
            const listaCnpj = lista?.filter(
                cnpj => removerMascara(cnpj)?.length === 14
            );

            return (
                listaCnpj?.filter(cnpj =>
                    row?.dadosDenucias.find(dado => {
                        const dadosDenuciasListaCpfCnpj =
                            dado.cpfCnpj?.split(',');
                        return (
                            dadosDenuciasListaCpfCnpj?.includes(cnpj) ||
                            dadosDenuciasListaCpfCnpj?.includes(
                                removerMascara(cnpj)
                            )
                        );
                    })
                ) || []
            );
        });

        const listaCarPositivo = computed(() => {
            const lista = row?.listaCar.split(',');
            const listaCar = lista?.filter(car => !!car);
            const listaDadosPositivos = row?.dadosDenucias;

            return (
                listaCar?.filter(car =>
                    listaDadosPositivos?.find(dado => {
                        const dadosDenuciasListaCar = dado.car?.split(',');
                        return (
                            dadosDenuciasListaCar?.includes(car) ||
                            dadosDenuciasListaCar?.includes(removerMascara(car))
                        );
                    })
                ) || []
            );
        });

        const listaCpfNegativo = computed(() => {
            const lista = row?.listaCpfCnpj.split(',');
            const listaCpf = lista?.filter(
                cpf => removerMascara(cpf)?.length === 11
            );

            return (
                listaCpf?.filter(
                    cpf =>
                        !row?.dadosDenucias.find(dado => {
                            const dadosDenuciasListaCpfCnpj =
                                dado.cpfCnpj?.split(',');
                            return (
                                dadosDenuciasListaCpfCnpj?.includes(cpf) ||
                                dadosDenuciasListaCpfCnpj?.includes(
                                    removerMascara(cpf)
                                )
                            );
                        })
                ) || []
            );
        });
        const listaCnpjNegativo = computed(() => {
            const lista = row?.listaCpfCnpj.split(',');
            const listaCnpj = lista?.filter(
                cnpj => removerMascara(cnpj)?.length === 14
            );

            return (
                listaCnpj?.filter(
                    cnpj =>
                        !row?.dadosDenucias.find(dado => {
                            const dadosDenuciasListaCpfCnpj =
                                dado.cpfCnpj?.split(',');
                            return (
                                dadosDenuciasListaCpfCnpj?.includes(cnpj) ||
                                dadosDenuciasListaCpfCnpj?.includes(
                                    removerMascara(cnpj)
                                )
                            );
                        })
                ) || []
            );
        });
        const listaCarNegativo = computed(() => {
            const lista = row?.listaCar.split(',');
            const listaCar = lista?.filter(car => !!car && isNaN(car[0]));
            const listaDadosPositivos = row?.dadosDenucias;

            return (
                listaCar?.filter(
                    car =>
                        !listaDadosPositivos?.find(dado => {
                            const dadosDenuciasListaCar = dado.car?.split(',');
                            return (
                                dadosDenuciasListaCar?.includes(car) ||
                                dadosDenuciasListaCar?.includes(
                                    removerMascara(car)
                                )
                            );
                        })
                ) || []
            );
        });

        function filtrarResultado() {
            const filtro = Object.keys(data.checkboxValues).filter(
                key => data.checkboxValues[key]
            );
            if (filtro.length === 0) {
                adicionarResultado(row.dadosDenucias);
            } else {
                const resultado = row.dadosDenucias.filter(dado => {
                    const dadosDenuciasListaCpfCnpj = dado.cpfCnpj
                        ?.split(',')
                        ?.map(d => removerMascara(d));
                    const dadosDenuciasListaCar = dado.car
                        ?.split(',')
                        ?.map(d => removerMascara(d));
                    return filtro.some(f => {
                        return (
                            dadosDenuciasListaCpfCnpj?.includes(
                                removerMascara(f)
                            ) ||
                            dadosDenuciasListaCar?.includes(removerMascara(f))
                        );
                    });
                });
                adicionarResultado(resultado);
            }
        }

        function mudarCheckbox(key) {
            const value = removerMascara(key);
            data.checkboxValues[value] = !data.checkboxValues[value];
            filtrarResultado();
        }

        function checked(key) {
            return data.checkboxValues[removerMascara(key)];
        }

        async function irListaDenuncia() {
            await vm.$router.push({
                name: 'denuncias'
            });
            state.resultado = null;
            state.quantidadeResultados = 0;
        }
        function exportElement() {
            const element = document.getElementById(
                'denuncia-resultado-exportar'
            );
            exportResults(element);
        }
        onMounted(() => {
            listaCarPositivo.value.forEach(car => {
                data.checkboxValues[removerMascara(car)] = false;
            });
            listaCpfPositivo.value.forEach(cpf => {
                data.checkboxValues[removerMascara(cpf)] = false;
            });
            listaCnpjPositivo.value.forEach(cnpj => {
                data.checkboxValues[removerMascara(cnpj)] = false;
            });
            adicionarResultado(row.dadosDenucias);
            data.resultados = row.dadosDenucias;
        });
        onUnmounted(() => {
            clear();
        });
        return {
            id,
            row,
            state,
            data,
            i18n,
            checked,
            translate,
            removerMascara,
            exportElement,
            irListaDenuncia,
            mudarCheckbox,
            filtrarResultado,
            listaCarNegativo,
            listaCpfPositivo,
            listaCarPositivo,
            listaCpfNegativo,
            listaCnpjPositivo,
            listaCnpjNegativo
        };
    }
});
</script>

<style lang="scss">
.visualizar-denuncia {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__titulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        color: var(--primary);
    }

    &__bloco {
        width: 100%;
    }

    &__card {
        background-color: $white;
        padding: 16px;
        border-radius: $default-border-radius;
        @include default-box-shadow();

        &--header {
            padding: 0;
        }
    }

    &__dados-pesquisados {
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(2, 1fr);
    }

    &__button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background-color: var(--primary);
        color: $white;
        height: 40px;
        padding: 16px;
        border: none;
        outline: none;
        border-radius: $default-border-radius;
        cursor: pointer;

        &--secondary {
            background: $white;
            color: var(--primary);
            border: 1px solid var(--primary);
        }

        &:disabled {
            background: #f5f5f5;
            color: #545454 !important;
            cursor: not-allowed;

            i {
                color: #545454 !important;
            }
        }
    }

    &__button-box,
    &__button-box.el-button--primary {
        background-color: var(--primary) !important;
        color: $white !important;
        border: none;
        outline: none;

        &:hover {
            background-color: var(--primary) !important;
            color: $white !important;
            border: none;
            outline: none;
        }
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 16px;
    }

    & .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid $default-border-color;
        padding: 12px 16px 16px;

        &__theader {
            font-size: 14px;
            min-width: 60px;
            font-weight: bold;
            text-align: center;
            color: var(--primary);
        }
    }

    & .card-bd {
        padding: 16px;
        max-height: 300px;
        min-height: 100px;
        overflow-x: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-thumb {
            border: 2px solid var(--white);
        }
    }

    & .resume {
        display: flex;
        gap: 80px;

        &__item {
            display: flex;
            flex-direction: column;
            gap: 5px;
            justify-content: space-between;

            &--normal {
                flex-direction: row;
            }
        }

        &__text {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        &__action {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
        }

        &__label {
            font-weight: bold;
            color: var(--primary);
        }

        &--vertical {
            flex-direction: column;
            gap: 5px;
        }
    }
}
</style>
